import axios from "axios";
import { LOGIN_API } from "./Constants";
export var base_url = "";

if (
  window.location.href.indexOf("democounseling") > -1 ||
  window.location.href.indexOf("localhost") > -1
) {
  base_url = "https://prod-api.brainhap.com/";
} else {
  base_url = "https://prod-api.brainhap.com/";
}
var creds_data = "";
var _access_token = "";
if (localStorage.hasOwnProperty("lcarro_user_creds_context")) {
  creds_data = JSON.parse(localStorage.getItem("lcarro_user_creds_context"));
  if (creds_data.hasOwnProperty("token")) {
    _access_token = creds_data.token.access;
  } else {
    _access_token = "";
  }
}

const headersObject = {
  "Content-Type": "application/json",
};

export var open_api = axios.create({
  baseURL: base_url,
  timeout: 300000000,
  headers: headersObject,

  transformRequest: [
    function (data, headers) {
      return JSON.stringify(data);
    },
  ],
});

export var token_api = axios.create({
  baseURL: base_url,
  timeout: 300000000,
  headers: headersObject,

  transformRequest: [
    function (data, headers) {
      return JSON.stringify(data);
    },
  ],
});

token_api.interceptors.request.use((req) => {
  var _access_token = "";
  if (localStorage.hasOwnProperty("lcarro_user_creds_context")) {
    creds_data = JSON.parse(localStorage.getItem("lcarro_user_creds_context"));
    if (creds_data.hasOwnProperty("token")) {
      _access_token = creds_data.token.access;
    } else {
      _access_token = "";
    }
  }
  req.headers.Authorization = `Bearer ${_access_token}`;
  return req;
});
